import { SxProps, Theme } from "@mui/material/styles";
import theme, { erreur, gris2 } from "../../theme";

const styles: SxProps<Theme> = [
  {
    "&.root": {
      display: "flex",
      flexDirection: "column",
    },
    "& .datepicker": {
      color: theme.palette.common.black,
      border: "1px solid " + theme.palette.primary.main,
    },
    "& .MuiInputBase-root": {
      color: theme.palette.common.black,
      backgroundColor: theme.palette.common.white,
      padding: 0,
      fontSize: "0.9rem",
      borderRadius: 0,
      fontWeight: "bold",
      "&::after, &::before": {
        border: "none",
      },
      "& > input": {
        padding: "15px 12px 7px",
        backgroundColor: theme.palette.common.white,
      },
      "&.Mui-error": {
        borderColor: erreur,
      },
      "&:hover": {
        backgroundColor: gris2,
      },
    },
    "& fieldset": {
      display: "none",
    },
    "& .inputLabelAsterisk": {
      "&.inputLabelError": {
        color: theme.palette.common.black,
      },
    },
    "& .MuiFormLabel-root": {
      fontSize: "0.8rem",
      color: theme.palette.common.black,
      fontWeight: "bold",
      transform: "translate(12px, 14px) scale(1)",
      "&.Mui-focused": {
        color: theme.palette.grey[400],
      },
      "&.MuiInputLabel-shrink": {
        transform: "translate(12px, 4px) scale(0.75)",
        fontSize: "1em",
        fontWeight: "normal",
        color: theme.palette.grey[400],
      },
      "&.Mui-error": {
        color: theme.palette.common.black,
      },
    },
    "& .underline": {
      "&::after, &::before": {
        border: "none",
      },
    },
    "& .iconCalendar": {
      marginLeft: "4px",
      marginTop: "2px",
    },
    "& .MuiButtonBase-root": {
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    "& .MuiInputAdornment-positionEnd": {
      padding: "0 16px 0 0px",
      "& svg": {
        // marginTop: "-4px",
        fill: theme.palette.primary.main,
      },
      "&:hover": {
        "& svg": {},
      },
    },
    "& .popup": {
      background: gris2,
    },
  },
];

export default styles;
